import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CpSigningUrlsService {
  constructor() { }
  signingUrlsObservable = new Subject<boolean>();

  setUrls(signingDetails) {
    const urls = signingDetails.map(detail => detail.signing_url);

    this.signingUrlsObservable.next(urls);
  }
}
